const wp = window.modern_tribe_config || {};

export const OFF_CANVAS_ITEMS = wp.off_canvas_items || {};
export const GLOBAL_NAV = OFF_CANVAS_ITEMS.global_nav || {};
